// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kDmo","right":"styles_right__1octC"};